import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../formTemplates/EntityManagement";
import EntityTable from "../templateComponents/EntityTable";

const BeaconType = () => {
  const [formData, setFormData] = useState({
    bec_typ_name: "",
  });

  const [beaconTypes, setBeaconTypes] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);

  const firstFormFieldRef = useRef(null);

  const endpoints = {
    viewAll: "/view_beacon_type/v1.1",
    register: "/registration_beacon_type/v1.1",
    update: "/update_beacon_type/v1.1",
  };

  const loadBeaconTypes = async () => {
    try {
      const response = await axiosInstance.post(endpoints.viewAll, {
        view_type: "view all",
      });

      if (response.data.Status === "Success") {
        setBeaconTypes(response.data.Data || []);
      } else {
        console.error("API error:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching beacon types:", error);
    }
  };

  useEffect(() => {
    loadBeaconTypes();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bec_typ_name) {
      alert("Please enter Beacon Type Name.");
      return;
    }

    const payload = {
      bec_typ_name: formData.bec_typ_name.trim(),
    };

    if (editMode) {
      payload.bec_typ_id = editingEntityId;

      try {
        const response = await axiosInstance.post(endpoints.update, payload);
        if (response.data.Status === "Success") {
          loadBeaconTypes();
          resetForm();
        } else {
          console.error("Update failed:", response.data.Message);
        }
      } catch (error) {
        console.error("Update error:", error);
      }
    } else {
      try {
        const response = await axiosInstance.post(endpoints.register, payload);
        if (response.data.Status === "Success") {
          loadBeaconTypes();
          resetForm();
        } else {
          console.error("Registration failed:", response.data.Message);
        }
      } catch (error) {
        console.error("Registration error:", error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      bec_typ_name: "",
    });
    setEditMode(false);
    setEditingEntityId(null);
  };

  const handleEdit = (entityId) => {
    const entity = beaconTypes.find((bt) => bt.bec_typ_id === entityId);
    if (entity) {
      setFormData({
        bec_typ_name: entity.bec_typ_name || "",
      });
      setEditMode(true);
      setEditingEntityId(entityId);
      if (firstFormFieldRef.current) firstFormFieldRef.current.focus();
      setIsTableModalOpen(false);
    }
  };

  const handleViewTableClick = () => {
    setIsTableModalOpen(true);
  };

  const formFields = [
    { name: "bec_typ_name", label: "Beacon Type Name", type: "text", required: true },
  ];

  const columns = [
    { name: "bec_typ_id", label: "Type ID" },
    { name: "bec_typ_name", label: "Type Name" },
    { name: "added_date", label: "Added Date" },
    { name: "updated_date", label: "Updated Date" },
  ];

  return (
    <div className="beacon-type">
      <EntityManagement
        entityName="Beacon Type"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
        onEdit={handleEdit}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={beaconTypes}
              columns={columns}
              onEdit={handleEdit}
              keyField="bec_typ_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BeaconType;
